export var BetActivityTurnoverQualificationType;
(function (BetActivityTurnoverQualificationType) {
    BetActivityTurnoverQualificationType[BetActivityTurnoverQualificationType["QUALIFIED"] = 0] = "QUALIFIED";
    BetActivityTurnoverQualificationType[BetActivityTurnoverQualificationType["UNQUALIFIED"] = 1] = "UNQUALIFIED";
})(BetActivityTurnoverQualificationType || (BetActivityTurnoverQualificationType = {}));
//# sourceMappingURL=BetActivityTurnoverQualificationType.js.map